<template>
  <main class="main main--has-floating-buttons grid--dense" style="grid-auto-rows: minmax(20rem, max-content);">
    <!--    <wizard :steps="['basic info', 'contact', 'billing']">-->
    <!--      <template slot-scope="slot">-->
    <!--        <div v-if="slot.activeStep === 1" class="col-12">-->
    <!--          <hm-card-inner title="Test1">-->
    <!--            <hm-col cols="12">-->
    <!--              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Tristique et egestas quis ipsum suspendisse ultrices gravida. Facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum. Cras semper auctor neque vitae. Ac tincidunt vitae semper quis lectus nulla. Morbi tempus iaculis urna id volutpat lacus. Volutpat commodo sed egestas egestas fringilla phasellus. Non consectetur a erat nam at lectus urna. Facilisis mauris sit amet massa vitae tortor condimentum lacinia. Ornare quam viverra orci sagittis eu. Tellus molestie nunc non blandit massa enim.</p>-->
    <!--              <p>Faucibus a pellentesque sit amet porttitor eget dolor. Sed augue lacus viverra vitae. Sit amet porttitor eget dolor. Tellus molestie nunc non blandit massa enim nec dui. Tortor posuere ac ut consequat semper viverra nam. Dignissim cras tincidunt lobortis feugiat vivamus at augue. Elementum curabitur vitae nunc sed velit. Amet mattis vulputate enim nulla aliquet porttitor lacus luctus. Elementum sagittis vitae et leo duis. Et egestas quis ipsum suspendisse ultrices. In cursus turpis massa tincidunt. Leo urna molestie at elementum eu facilisis sed odio. Volutpat odio facilisis mauris sit amet massa vitae. Ante in nibh mauris cursus mattis molestie a. Ornare quam viverra orci sagittis eu. Sit amet luctus venenatis lectus magna. Sed augue lacus viverra vitae congue eu consequat ac. In hac habitasse platea dictumst quisque sagittis purus. Phasellus egestas tellus rutrum tellus pellentesque. Leo vel fringilla est ullamcorper eget.</p>-->
    <!--            </hm-col>-->
    <!--          </hm-card-inner>-->
    <!--        </div>-->
    <!--        <div v-if="slot.activeStep === 2" class="col-12">-->
    <!--          <hm-card-inner title="Step2 - Test1">-->
    <!--            <hm-col cols="12">-->
    <!--              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Tristique et egestas quis ipsum suspendisse ultrices gravida. Facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum. Cras semper auctor neque vitae. Ac tincidunt vitae semper quis lectus nulla. Morbi tempus iaculis urna id volutpat lacus. Volutpat commodo sed egestas egestas fringilla phasellus. Non consectetur a erat nam at lectus urna. Facilisis mauris sit amet massa vitae tortor condimentum lacinia. Ornare quam viverra orci sagittis eu. Tellus molestie nunc non blandit massa enim.</p>-->
    <!--              <p>Faucibus a pellentesque sit amet porttitor eget dolor. Sed augue lacus viverra vitae. Sit amet porttitor eget dolor. Tellus molestie nunc non blandit massa enim nec dui. Tortor posuere ac ut consequat semper viverra nam. Dignissim cras tincidunt lobortis feugiat vivamus at augue. Elementum curabitur vitae nunc sed velit. Amet mattis vulputate enim nulla aliquet porttitor lacus luctus. Elementum sagittis vitae et leo duis. Et egestas quis ipsum suspendisse ultrices. In cursus turpis massa tincidunt. Leo urna molestie at elementum eu facilisis sed odio. Volutpat odio facilisis mauris sit amet massa vitae. Ante in nibh mauris cursus mattis molestie a. Ornare quam viverra orci sagittis eu. Sit amet luctus venenatis lectus magna. Sed augue lacus viverra vitae congue eu consequat ac. In hac habitasse platea dictumst quisque sagittis purus. Phasellus egestas tellus rutrum tellus pellentesque. Leo vel fringilla est ullamcorper eget.</p>-->
    <!--            </hm-col>-->
    <!--          </hm-card-inner>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--      <template slot="buttons" slot-scope="slot">-->
    <!--        <hm-button class="" cols="6" icon-left="back-1" @click="slot.changeStep(slot.activeStep - 1)">Zurück</hm-button>-->
    <!--        <hm-button class="" cols="6" icon-left="forward-1" @click="slot.changeStep(slot.activeStep + 1)">Weiter</hm-button>-->
    <!--      </template>-->
    <!--    </wizard>-->

    <card :title="$t('pageFrontDesk.card.systemStatus')"
          :rows="systemStatus === 'ok' ? 'start-3' : ''"
          content-clickable
          cols="12 6@tablet 4@desktop 3@hd start-1"
          @clickContent="clickStatus">
      <template slot="header-right">
        <small class="version">{{ version }}</small>
      </template>
      <hm-col cols="12">
        <hint :text="$t(`systemStatus.${systemStatus}`)" :icon="systemStatus"></hint>
      </hm-col>
    </card>

    <tabable-card v-if="hasRole('ROLE_USER')"
                  id="arrivals-departures-list"
                  cols="12 6@tablet 4@desktop 3@hd start-1"
                  rows="2"
                  max-height="72rem">
      <tabable-card-content id="arrivals" :title="$t('pageFrontDesk.card.arrivals')">
        <spinner-overlay v-if="isNil(reservations)" />
        <hm-card-inner :full-size="true">
          <hm-table :hover="false"
                    :sticky="true"
                    columns="4"
                    grid-template-columns="auto max-content minmax(min-content, 7rem) minmax(4.7rem, max-content)"
                    min-width="40rem">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageFrontDesk.arrivals.name') }}</div>
              <div class="hm-table__th">{{ $t('pageFrontDesk.arrivals.arrivalDate') }}</div>
              <div class="hm-table__th">{{ $t('pageFrontDesk.arrivals.roomNumber') }}</div>
              <div class="hm-table__th"></div>
            </template>
            <template v-for="row in arrivals">
              <div class="hm-table__td hm-table__td--clickable privacy--blur" @click="routeToReservation(row.id)">{{ row.displayName }}</div>
              <div class="hm-table__td">{{ row.checkInDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td">{{ row.roomNumber }}</div>
              <div class="hm-table__td hm-table__td--icon">
                <span v-tooltip="{ title: $t('pageFrontDesk.actionCheckIn'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="reservationAction(row.id, 'checkIn')">
                  <icon icon="checkin" />
                </span>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content :title="$t('pageFrontDesk.card.departures')">
        <spinner-overlay v-if="isNil(reservations)" id="departures" />
        <hm-card-inner :full-size="true">
          <hm-table :hover="false"
                    :sticky="true"
                    columns="4"
                    grid-template-columns="auto max-content minmax(min-content, 7rem) minmax(4.7rem, max-content)"
                    min-width="40rem">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageFrontDesk.departures.name') }}</div>
              <div class="hm-table__th">{{ $t('pageFrontDesk.departures.departureDate') }}</div>
              <div class="hm-table__th">{{ $t('pageFrontDesk.departures.roomNumber') }}</div>
              <div class="hm-table__th"></div>
            </template>
            <template v-for="row in departures">
              <div class="hm-table__td hm-table__td--clickable privacy--blur" @click="routeToReservation(row.id)">{{ row.displayName }}</div>
              <div class="hm-table__td">{{ row.checkOutDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td">{{ row.roomNumber }}</div>
              <div class="hm-table__td hm-table__td--icon">
                <span v-tooltip="{ title: $t('pageFrontDesk.actionCheckOut'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="reservationAction(row.id, 'checkOut')">
                  <icon icon="checkout" />
                </span>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content id="inhouse" :title="$t('pageFrontDesk.card.inHouse')">
        <spinner-overlay v-if="isNil(reservations)" />
        <hm-card-inner :full-size="true">
          <hm-table :hover="false"
                    :sticky="true"
                    columns="4"
                    grid-template-columns="auto max-content minmax(min-content, 7rem) minmax(4.7rem, max-content)"
                    min-width="45rem">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageFrontDesk.inHouse.name') }}</div>
              <div class="hm-table__th">{{ $t('pageFrontDesk.inHouse.departureDate') }}</div>
              <div class="hm-table__th">{{ $t('pageFrontDesk.inHouse.roomNumber') }}</div>
              <div class="hm-table__th"></div>
            </template>
            <template v-for="row in inHouse">
              <div class="hm-table__td hm-table__td--clickable privacy--blur" @click="routeToReservation(row.id)">{{ row.displayName }}</div>
              <div class="hm-table__td">{{ row.checkOutDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td">{{ row.roomNumber }}</div>
              <div class="hm-table__td hm-table__td--icon">
                <span v-tooltip="{ title: $t('pageFrontDesk.actionUndoCheckIn'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="reservationAction(row.id, 'undoCheckIn')">
                  <icon icon="undo" />
                </span>
                <span v-tooltip="{ title: $t('pageFrontDesk.actionCheckOut'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="reservationAction(row.id, 'checkOut')">
                  <icon icon="checkout" />
                </span>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
    </tabable-card>

    <!--    <card v-if="hotelSettings.hotel.whiteLabel === 'Hotelmeister' && (hotelSettings.details.countryCode === 'DE') && hasLicense('Payments')"-->
    <!--          cols="12 6@tablet 4@desktop 3@hd"-->
    <!--          rows="3"-->
    <!--          title="Wichtige Information">-->
    <!--      <hm-card-inner :full-size="true">-->
    <!--        <hm-col cols="12">-->
    <!--          <span class="error-text error-text&#45;&#45;full-size error-text&#45;&#45;no-margin col-12">Falls Sie in Ihrem Betrieb nicht hierfür zuständig sind, so informieren Sie bitte umgehend die betreffende Person.</span>-->
    <!--        </hm-col>-->
    <!--      </hm-card-inner>-->
    <!--      <hm-card-inner title="Information">-->
    <!--        <hm-col cols="12">-->
    <!--          <p>Die letzte Übergangsfrist für die Umsetzung der <b>KassenSichV</b> endet am <b>31. März 2021</b>.</p>-->
    <!--          <p>Wenn Sie in Hotelmeister zumindest teilweise bare Zahlungen erfassen, dazu zählen auch viele andere Zahlungsmittel und Gutscheine, dann gilt die Hotelsoftware als Kasse und <b>muss mit einer TSE abgesichert werden</b>.</p>-->
    <!--          <p>Sie haben Ende letzter Woche eine E-Mail diesbezüglich erhalten, mit dem Betreff <i>"DRINGEND!! Kassensicherheitsverordnung"</i>. Falls Sie diese E-Mail nocht nicht gelesen haben, dann lesen Sie diese bitte jetzt - sie enthält individuelle Informationen für Ihren Betrieb.</p>-->
    <!--        </hm-col>-->
    <!--      </hm-card-inner>-->
    <!--      <hm-card-inner title="Einrichtung der TSE">-->
    <!--        <hm-col cols="12">-->
    <!--          <p>Wenn Sie die TSE bereits beauftragt haben, dann beginnen Sie bitte <b>umgehend</b> damit den Assistenten zur Einrichtung abzuarbeiten.</p>-->
    <!--          <hm-button class="btn&#45;&#45;green"-->
    <!--                     cols="12 6@tablet 3@desktop 2@hd"-->
    <!--                     icon-left="forward-2c"-->
    <!--                     @click="$router.push({ name: 'enableKassenSichV' })"-->
    <!--          >Assistent öffnen</hm-button>-->
    <!--          <p>Darüber hinaus registrieren Sie sich bitte bei Fiskaltrust, damit wir die TSE für Sie konfigurieren können.</p>-->
    <!--          <hm-button class="btn&#45;&#45;gray"-->
    <!--                     cols="12 6@tablet 3@desktop 2@hd"-->
    <!--                     icon-left="info"-->
    <!--                     @click="openFiskaltrustRegistrationInfoPage()"-->
    <!--          >Registrierung Fiskaltrust</hm-button>-->
    <!--        </hm-col>-->
    <!--      </hm-card-inner>-->
    <!--      <hm-card-inner title="Folgen bei Nichtbeauftragung">-->
    <!--        <hm-col cols="12">-->
    <!--          <p>-->
    <!--            Wenn Sie nach dem Ende der allgemeinen Übergangsfrist, d.h. nach dem 30.09.2020, vor Ort Zahlungen in Hotelmeister erfasst haben, so können diese bei einer zukünftigen Betriebsprüfung beanstandet werden, wenn die Hotelsoftware nicht bis 31.03.2021 mit einer TSE abgesichert wird.-->
    <!--          </p>-->
    <!--          <p>-->
    <!--            Da die Inverkehrbringung von Systemen, welche die Möglichkeit bieten bare Zahlungsvorgänge zu erfassen, verboten ist - wird Möglichkeit zur Erfassung von vor Ort Zahlungen für alle Betriebe ohne TSE ab 01.04.2021 deaktiviert.-->
    <!--          </p>-->
    <!--        </hm-col>-->
    <!--      </hm-card-inner>-->
    <!--    </card>-->

    <card v-if="hasRole('ROLE_USER')" id="statistics" :title="$t('pageFrontDesk.card.frontDesk')" cols="12 6@tablet 4@desktop 3@hd">
      <spinner-overlay v-if="isEmpty(statistics)" />
      <hm-card-inner :title="$t('pageFrontDesk.card.arrivalStatistics')">
        <label-value-dotted :value="statistics.totalArrivals || 0" :clickable="true" :label="$t('pageFrontDesk.statistics.plannedArrivals')" @click="routeToFindReservation({arrivalsOnly: true})" />
        <label-value-dotted :value="statistics.arrived || 0" :clickable="true" :label="$t('pageFrontDesk.statistics.arrived')" @click="routeToFindReservation({arrivalsOnly: true, status: 'InHouse'})" />
        <label-value-dotted :value="statistics.awaitingArrival || 0" :clickable="true" :label="$t('pageFrontDesk.statistics.awaitingArrival')" @click="routeToFindReservation({arrivalsOnly: true})" />
      </hm-card-inner>
      <hm-card-inner :title="$t('pageFrontDesk.card.departureStatistics')">
        <label-value-dotted :value="statistics.totalDepartures || 0" :clickable="true" :label="$t('pageFrontDesk.statistics.plannedDepartures')" @click="routeToFindReservation({departuresOnly: true})" />
        <label-value-dotted :value="statistics.departed || 0" :clickable="true" :label="$t('pageFrontDesk.statistics.departed')" @click="routeToFindReservation({departuresOnly: true, status: 'Departed'})" />
        <label-value-dotted :value="statistics.awaitingDeparture || 0" :clickable="true" :label="$t('pageFrontDesk.statistics.awaitingDeparture')" @click="routeToFindReservation({departuresOnly: true, status: 'InHouse'})" />
      </hm-card-inner>
    </card>


    <card v-if="hasRole('ROLE_FINANCIAL_REPORTS') && hotelSettings.hotel.whiteLabel === 'Hotelmeister' && (hotelSettings.details.countryCode === 'AT') && hasLicense('EU_AT_Registrierkasse') && $moment().format('MMDD') <= '0215'"
          cols="12 6@tablet 4@desktop 3@hd"
          rows="1"
          title="Registrierkasse Jahresbeleg">
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <span class="warning-text warning-text--full-size warning-text--no-margin col-12"><b>Erinnerung</b>: Überprüfung Jahresbeleg (Registierkasse) bis spätestens <b>15. Februar</b></span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <hm-col cols="12">
          <p>Zum Jahreswechsel hat deine in Hotelmeister integrierte Registrierkasse automatisch den Jahresbeleg erstellt.</p>
          <p>Dieser Jahresbeleg muss bis spätestens <b>15. Februar</b> von dir, bzw. deinem Steuerberater im Finanz-Online überprüft werden. Eine kurze Anleitung dazu findest du in unserer <a href="https://docs.hotelmeister.io/registrierkasse-jahresbeleg-uberprufen#sy4sY" target="_blank">Dokumentation</a>.</p>
          <hm-button class="btn--green btn--no-margin"
                     cols="12 6@tablet 3@desktop 2@hd"
                     icon-left="printer"
                     @click="downloadYearReceiptAT">Jahresbeleg drucken</hm-button>
          <p><small><i>Der Betrag von 0,00 € auf dem Jahresbeleg ist gesetzlich vorgeschrieben. Der für das Finanzamt relevante Umsatzzähler ist im QR-Code enthalten.</i></small></p>
        </hm-col>
      </hm-card-inner>
    </card>

    <tabable-card v-if="hasRole('ROLE_USER')" id="notes" cols="12 6@tablet 4@desktop 3@hd" max-height="40rem">
      <tabable-card-content :title="$t('pageFrontDesk.card.notes')">
        <spinner-overlay v-if="isNil(notes)" />
        <hm-card-inner :full-size="true">
          <hm-table :sticky="true"
                    :hover="false"
                    columns="2"
                    grid-template-columns="auto minmax(4.7rem, max-content)"
                    class="hm-table--notes">
            <contenteditable-div v-model="newNote"
                                 :key="isNil(notes) ? 0 : notes.length"
                                 :placeholder="$t('pageFrontDesk.placeholderNewNote')"
                                 class="hm-table__td"
                                 @blur="addNote"
                                 @submit="addNote" />
            <div class="hm-table__td hm-table__td--icon hm-table__td--stick-bottom">
              <span v-tooltip="{ title: $t('pageFrontDesk.actionAddNote'), delay: 250, placement: 'bottom', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="addNote()">
                <icon icon="plus" />
              </span>
            </div>
            <template v-for="note in notes">
              <div v-tooltip="{ title: note.message, delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: true }" v-if="(note.message || '').length > 50" class="hm-table__td privacy--blur">{{ note.message }}</div>
              <div v-else class="hm-table__td privacy--blur">{{ note.message }}</div>
              <div class="hm-table__td hm-table__td--icon hm-table__td--icon--transparent">
                <span v-tooltip="{ title: $t('pageFrontDesk.actionArchiveNote'), delay: 250, placement: 'left', positionFixed: true, trigger: 'hover', touch: false }" class="quick-action-button" @click="deleteNote(note.id)">
                  <icon icon="save" />
                </span>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content :title="$t('pageFrontDesk.card.notesArchive')">
        <spinner-overlay v-if="isNil(notes)" />
        <hm-card-inner :full-size="true">
          <hm-table :sticky="true" :hover="false" columns="2" grid-template-columns="1fr">
            <template v-for="note in notesArchive">
              <div v-tooltip="{ title: note.message, delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: true }" class="hm-table__td privacy--blur">{{ note.message }}</div>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
    </tabable-card>

    <card v-if="hotelSettings.details.latitude != 0 && hotelSettings.details.longitude != 0" id="weather" :title="hotelSettings.details.hotelCity" cols="12 6@tablet 4@desktop 3@hd">
      <spinner-overlay v-if="isNil(weather)" />
      <template v-else>
        <template v-if="!isEmpty(weather.VisualCrossing)">
          <hm-card-inner >
            <hm-col :grid="true">
              <hm-col cols="10">
                <div style="display:grid;grid-template-columns: min-content min-content;">
                  <span style="font-size:5rem;font-weight:bold;">{{ weather.VisualCrossing.currentConditions.temp | round }}</span>
                  <span style="font-size:3.5rem;">°C</span>
                </div>
                <p v-html="weather.VisualCrossing.currentConditions.conditions"></p>
              </hm-col>
              <hm-col cols="2">
                <icon :icon="`fill-weather-${weather.VisualCrossing.currentConditions.icon}`" />
              </hm-col>
            </hm-col>
          </hm-card-inner>
          <hm-card-inner :full-size="true">
            <hm-table :hover="false" :display-last-line="true" columns="5" grid-template-columns="14rem auto 6rem 6rem 6rem">
              <template v-for="(date, idx) in weather.VisualCrossing.days" v-if="idx < 4">
                <div class="hm-table__td hm-table__td--th">{{ $moment(date.datetime).format('dd D.M.YYYY') }}</div>
                <div v-tooltip="{ title: date.description, delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: true }" class="hm-table__td">
                  {{ date.description }}
                </div>
                <div class="hm-table__td" style="padding-left:0;"><icon :icon="`fill-weather-${date.icon}`" /></div>
                <div class="hm-table__td text-right" style="padding-left:0;">{{ date.tempmin | round }}°C</div>
                <div class="hm-table__td text-right" style="padding-left:0;">{{ date.tempmax | round }}°C</div>
              </template>
            </hm-table>
            <hm-col :grid="true" cols="12" class="weather--attribution">
              <span class="text-block--info col-6" style="width: 100%;font-size:80%;text-align:left;">Last Refresh: {{ weather.lastModified | toLocalDateTime }}</span>
              <a class="col-6" href="https://www.visualcrossing.com/weather-data" target="_blank" rel="noopener noreferrer">Visual Crossing Weather</a>
            </hm-col>
          </hm-card-inner>
        </template>
      </template>
    </card>

    <card v-if="hotelSettings.hotel.whiteLabel === 'Hotelmeister'"
          title="Updates"
          rows="3"
          cols="12 6@tablet 4@desktop 3@hd"
          content-style-class="card__content--full-height">
      <hm-card-inner :full-size="true" style="grid-template-rows: 1fr;">
        <iframe src="https://app.loopedin.io/hotel-management-software/updates" class="col-12" style="min-height: 100%;border: none;padding: 0 1.6rem;" />
      </hm-card-inner>
    </card>

    <card v-if="!isEmpty(birthdays) && hasRole('ROLE_USER')" id="birthdays" :title="$t('pageFrontDesk.card.birthdays')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner :full-size="true">
        <hm-table columns="3">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('pageFrontDesk.birthdays.name') }}</div>
            <div class="hm-table__th">{{ $t('pageFrontDesk.birthdays.age') }}</div>
            <div class="hm-table__th">{{ $t('pageFrontDesk.birthdays.roomNumber') }}</div>
          </template>
          <template slot="default">
            <template v-for="row in birthdays">
              <div class="hm-table__td privacy--blur" @click="routeToReservation(row.reservationId)">{{ row.guestName }}</div>
              <div class="hm-table__td" @click="routeToReservation(row.reservationId)">{{ row.age }}</div>
              <div class="hm-table__td" @click="routeToReservation(row.reservationId)">{{ row.roomNumber }}</div>
            </template>
          </template>
        </hm-table>
      </hm-card-inner>
    </card>

    <template v-if="hasRole('ROLE_ADMIN') || hasRole('ROLE_SYSADMIN')">
      <card v-if="!isEmpty(configurationErrors)" :title="$t('ConfigurationError.title')" :rows="`${Math.round(configurationErrors.length / 10) + 1}`" cols="12 12@tablet 8@desktop 6@hd">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">{{ $t('ConfigurationError.infoText') }}</span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="max-content 4fr">
            <template v-for="err in configurationErrors">
              <div class="hm-table__td" @click="onClickConfigurationError(err)">
                <i v-if="err.severity === 'Error'" class="fal fa-bug color--red" />
                <i v-else class="fal fa-exclamation-triangle color--warn" />
              </div>
              <div :class="[{'color--red': err.severity === 'Error'}, {'color--warn': err.severity !== 'Error'}]"
                   :title="err.message"
                   class="hm-table__td"
                   @click="onClickConfigurationError(err)">{{ err.message }}</div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>


      <card id="keyboardshortcuts" :center="true" :title="$t('pageFrontDesk.card.keyboardShortcuts')" cols="12 6@tablet 4@desktop 3@hd">
        <hm-card-inner :full-size="true">
          <hint :text="$t('pageFrontDesk.hintShowKeyboardShortcuts')"></hint>
        </hm-card-inner>
      </card>

    </template>
  </main>
</template>


<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { head, isEmpty, isNil, reverse } from 'lodash';
import HmCardInner from '../lib/layout/HmCardInner';
import HmCol from '../lib/layout/HmCol';
import HmInput from '../lib/inputs/HmInput';
import ContenteditableDiv from '../lib/util/ContenteditableDiv';
import Hint from '../lib/util/Hint';
import PageMixin from '../../mixins/PageMixin';
import StatusMixin from '../../mixins/StatusMixin';
import ConfigErrorMixin from '../../mixins/ConfigErrorMixin';
import HmButton from '../lib/buttons/HmButton';

export default {
  name: 'PageFrontDesk',
  components: { HmButton, Hint, ContenteditableDiv, HmCardInner, HmInput, HmCol },

  timers: {
    autoUpdateData: {
      time: 3 * 60 * 1000, // every 3 minutes
      autostart: true,
      repeat: true,
    },
    updateWeather: {
      time: 60 * 60 * 1000, // every hour
      autostart: true,
      repeat: true,
    },
  },

  filters: {
    round(value) {
      return Math.round(value);
    },
  },
  mixins: [HotelmeisterMixin, PageMixin, StatusMixin, ConfigErrorMixin],

  data() {
    return {
      statistics: {},
      notes: null,
      notesArchive: [],
      birthdays: [],
      newNote: null,
      archivedNoteCheckbox: true,
      reservations: null,
      weather: {},
    };
  },

  computed: {
    arrivals: function () {
      return isNil(this.reservations) ? [] : this.reservations.filter(it => it.status === 'NonGuaranteed' || it.status === 'Guaranteed' || it.status === 'AwaitingPayment').sort((a, b) => a.checkInDate - b.checkInDate);
    },
    departures: function () {
      const today = this.$moment().format('YYYYMMDD');
      return isNil(this.reservations) ? [] : this.reservations.filter(it => it.status === 'InHouse' && it.checkOutDate === today).sort((a, b) => a.checkOutDate - b.checkOutDate);
    },
    inHouse: function () {
      return isNil(this.reservations) ? [] : this.reservations.filter(it => it.status === 'InHouse').sort((a, b) => a.checkOutDate - b.checkOutDate);
    },
    version() {
      return `Version: ${(this.env('VERSION') || '-').split('-')[0]}`;
    },
  },

  created: function () {
    this.updateStatistics();
    this.updateBirthdays();
    this.updateNotes();
    this.updateNotesArchive();
    this.updateReservations();
    this.updateWeather();

    this.$serviceBus.$on('help.show', this.showHelp);

    try {
      // eslint-disable-next-line no-undef
      ps_config.firstname = process.env.HOTELMEISTER_ENV;
      // eslint-disable-next-line no-undef
      ps_config.lastname = this.hotelSettings.hotel.hotelName;
      // eslint-disable-next-line no-undef
      ps_config.name = this.hotelSettings.hotel.hotelName;
      // eslint-disable-next-line no-undef
      ps_config.email = this.hotelSettings.details.emailReservation;

      // eslint-disable-next-line no-undef
      ps_config.segment = { country: this.hotelSettings.details.countryCode };

      // eslint-disable-next-line no-empty
    } catch (e) { }
  },

  mounted() {
    document.querySelector('body').classList.add('productstash');
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('productstash');
  },

  methods: {
    env: function (name) {
      return process.env[name];
    },
    clickStatus() {
      if (this.hotelSettings.hotel.whiteLabel === 'Hotelmeister') {
        window.open('https://status.hotelmeister.com', '_blank');
      } else {
        window.open('https://status.hotelsoftware.io', '_blank');
      }
    },
    showHelp() {
      this.$driver.defineSteps([
        {
          element: '#header',
          padding: 0,
          popover: {
            title: 'Header',
            description: '<b>Hotelname, Benutzername, Benachrichtigungen</b><br/><br/>Zeigt Ihnen bei welchem Hotel Sie angemeldet sind - ideal wenn Sie mehrere Instanzen haben.<br/><br/> Der aktuell angemeldete Benutzer - zur Kontrolle wenn Sie Ihren Arbeitsplatz mit Kollegen teilen.<br/><br/> Bei bestimmten Ereignissen (z.B. neue Reservierung über Webseite, abgelaufe Option, Ausfall der Registrierkasse, ...) erhalten Sie Benachrichtigungen von Hotelmeister.<br/>',
            position: 'bottom',
            offset: 100,
          },
        },
        {
          element: '#main-nav',
          padding: 0,
          popover: {
            title: 'Hauptmenü',
            description: 'Hier können Sie ganz schnell zwischen Zimmerplan, Reservierungssuche, Gästekartei und vielen weiteren Punkten wechseln.',
            position: 'right',
            offset: 100,
          },
        },
        {
          element: '#support',
          padding: 0,
          popover: {
            title: 'Support',
            description: 'Hier erhalten Sie kontextbezogene Hilfestellungen, Zugriff auf unsere Lösungsdatenbank und können bei Fragen unser Support-Team kontaktieren.',
            position: 'left',
          },
        },
        {
          element: '#arrivals-departures-list',
          popover: {
            title: 'Anreisen, Abreisen, Im Haus',
            description: 'Sehen Sie auf einen Blick wer heute noch anreist oder abreist oder bereits im Haus ist.',
            position: 'right',
            offset: 100,
          },
        },
        {
          element: '#statistics',
          popover: {
            title: 'Rezeption',
            description: 'Zeigt auf einen Blick wie viele An- und Abreisen heute noch anstehen.',
            position: 'right',
            offset: 100,
          },
        },
        {
          element: '#notes',
          popover: {
            title: 'Notizen',
            description: 'Dank unserer innovativen Hotelsoftware müssen Sie keine Post-Its mehr auf Ihren Bildschirm kleben - Sie haben Ihre Notizen immer dabei.',
            position: 'left',
            offset: 100,
          },
        },
      ]);
      this.$driver.start();
    },
    autoUpdateData() {
      this.updateStatistics();
      this.updateBirthdays();
      this.updateNotes();
      this.updateNotesArchive();
      this.updateReservations();
    },
    reservationAction(reservationId, reservationAction) {
      this.$store.commit('save/started', reservationId);
      this.axios.post(this.serviceUrls.reservation.action(this, reservationId, reservationAction))
        .then((response) => {
          this.showSuccessMessage();
          this.$store.commit('save/finished', reservationId);
          this.updateReservations();
        })
        .catch((error) => {
          this.$store.commit('save/finished', reservationId);
          this.showMessages(error.response);
        });
    },
    routeToFindReservation(params = {}) {
      this.$router.push({
        name: 'findReservation',
        query: {
          startDate: this.$moment().format('YYYYMMDD'),
          endDate: this.$moment().format('YYYYMMDD'),
          limit: 250,
          excludeOnRequest: true,
        },
        params: {
          ...params,
        },
      });
    },
    routeToReservation(reservationId) {
      this.$router.push({ name: 'reservation', params: { reservationId: reservationId } });
    },
    addNote() {
      const msg = this.newNote;
      this.newNote = null;
      if (isEmpty(msg)) return;

      this.axios.post(this.serviceUrls.frontDesk.notes(this), { message: msg }).then((response) => {
        this.updateNotes();
        this.updateNotesArchive();
      });
    },
    deleteNote(noteId) {
      this.axios.delete(this.serviceUrls.frontDesk.note(this, noteId)).then((response) => {
        this.updateNotes();
        this.updateNotesArchive();
      });
    },
    updateStatistics() {
      this.axios.get(this.serviceUrls.frontDesk.statistic(this)).then((response) => {
        this.statistics = response.data.data;
      });
    },
    updateBirthdays() {
      this.axios.get(this.serviceUrls.frontDesk.birthday(this)).then((response) => {
        this.birthdays = response.data.data;
      });
    },
    updateNotes() {
      this.axios.get(this.serviceUrls.frontDesk.notes(this)).then((response) => {
        this.notes = reverse(response.data.data);
      });
    },
    updateWeather() {
      this.axios.get(this.serviceUrls.weather(this)).then((response) => {
        this.weather = response.data.data;
      });
    },
    updateNotesArchive() {
      this.axios.get(this.serviceUrls.frontDesk.notesArchive(this)).then((response) => {
        this.notesArchive = reverse(response.data.data);
      });
    },
    updateReservations() {
      this.axios.get(this.serviceUrl('reservation.find'), {
        params: {
          from: this.$moment().format('YYYYMMDD'),
          until: this.$moment().format('YYYYMMDD'),
          limit: 500,
          excludeOnRequest: true,
        },
      })
        .then((response) => {
          this.reservations = response.data.data.filter((it) => {
            if (it.type === 'OnRequest' && this.$moment(it.checkInDate, 'YYYYMMDD').isAfter(this.$moment())) return false;
            else if (it.type === 'OnRequest' && this.$moment(it.checkOutDate, 'YYYYMMDD').isBefore(this.$moment())) return false;
            else return true;
          });

          const roomNumbers = this.hotelSettings.rooms.map(it => it.roomNumber);

          this.reservations.sort((a, b) => roomNumbers.indexOf(a.roomNumber) - roomNumbers.indexOf(b.roomNumber));
        });
    },
    openImportantInformationPage() {
      window.open('https://docs.hotelmeister.io/[de]-kassensicherheitsverordnung', '_blank');
    },
    openFiskaltrustRegistrationInfoPage() {
      window.open('https://docs.hotelmeister.io/registrierung-fiskaltrust', '_blank');
    },
    onClickConfigurationError(err) {
      switch (err.type) {
        case 'RatePlan':
          this.$router.push({
            name: 'ratePlan',
            params: {
              ratePlanId: err.id,
            },
          });
          break;
        case 'InHouseService':
          this.$router.push({
            name: 'inHouseService',
            params: {
              inHouseServiceId: err.id,
            },
          });
          break;
        case 'MealPlan':
          this.$router.push({
            name: 'mealPlan',
            params: {
              mealPlanId: err.id,
            },
          });
          break;
        case 'Tax':
          if (isEmpty(err.id)) {
            this.$router.push({
              name: 'taxes',
            });
          } else {
            this.$router.push({
              name: 'tax',
              params: {
                taxId: err.id,
              },
            });
          }
          break;
        case 'Hotel':
          this.$router.push({
            name: 'hotel',
          });
          break;
        default:
          // do nothing
          break;
      }
    },
    printHTML(url) {
      this.$serviceBus.$emit('printHTML', url);
    },
    downloadYearReceiptAT() {
      this.axios.get(this.serviceUrls.registrierkasse.at.listReceipts(this))
        .then((response) => {
          const previousYear = `${new Date().getFullYear() - 1}`;
          const yearReceipts = response.data.data.filter(receiptHolder => receiptHolder.receipts.filter(receipt => receipt.flags.includes('YearReceipt')).length > 0);
          const lastYearReceipt = head(yearReceipts.filter(receiptHolder => receiptHolder.receipts.filter(receipt => receipt.additionalFields.EU_AT_YEAR === previousYear).length > 0));
          if (lastYearReceipt) {
            this.printHTML(
              window.getOldUIPath(
                this.hotelSettings.tenant.subdomain,
                this.hotelSettings.hotel.id,
                `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${this.hotelSettings.hotel.id}&receiptHolderId=${lastYearReceipt.id}&receiptSeq=0`,
                window.getToken(this.$route.params.hotelId),
                null,
                true,
              ),
            );
          } else {
            this.showConfirmModal('Der Jahresbeleg wurde nicht nicht gefunden. Falls ihre Registrierkasse erst im aktuellen Jahr in Betrieb genommen wurde, können Sie den Hinweis zur Überprüfung des Jahresbelegs ignorieren.');
          }
        });
    },
  },
};
</script>

<style lang="scss">
.card__content--full-height {
  display: grid !important;
  grid-template-rows: 1fr;

  .card__content__inner {
    grid-template-rows: 1fr;
  }
}

</style>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .weather {
    &--attribution {
      text-align: right;
      padding: 1.0rem 1.5rem;
      a {
        font-size: 80%;
        color: $text;
      }
    }
  }

  .hm-table--notes {
    .hm-table__td {
      &--icon {

        &--transparent {
          @include icon-color(transparent);

          .quick-action-button {
            padding: 0.9rem;
          }
          .hm-icon {
            &:after {
              content: ' ';
              position: absolute;
              top: 1.3rem;
              left: 1.3rem;
              right: 1.3rem;
              bottom: 1.3rem;
              border: 1px solid $middlegray;
            }

            &:hover:after {
              border: 1px solid $mint;
            }
          }
        }
      }
    }
  }

  .hm-table--condensed {
    &.hm-table--notes {
      .hm-table__td {
        &--icon {
          &--transparent {
            .quick-action-button {
              padding: 0;
            }
            .hm-icon {
              &:after {
                top: 0.6rem;
                left: 0.6rem;
                right: 0.6rem;
                bottom: 0.6rem;
              }

            }
          }
        }
      }
    }
  }

  .version {
    color: $gray;
  }


</style>



// WEBPACK FOOTER //
// src/components/pages/PageFrontDesk.vue